// extracted by mini-css-extract-plugin
export default {"container":"multiEdit_container__DERpA","wrapper":"multiEdit_wrapper__2vLsc","chartArea":"multiEdit_chartArea__hWf6e","footerArea":"multiEdit_footerArea__yhTXx"};